/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Overview_Start_Round_HintInputs */



/**
* | output |
* | --- |
* | "Need at least 4 checked-in players ({count} currently)." |
*
* @param {Overview_Start_Round_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_start_round_hint = /** @type {((inputs: Overview_Start_Round_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Start_Round_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Il faut au moins 4 joueurs pointés (${i?.count} actuellement).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se necesitan al menos 4 jugadores con check-in (${i?.count} actualmente).`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`São necessários pelo menos 4 jogadores com check-in (${i?.count} atualmente).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Servono almeno 4 giocatori con check in (${i?.count} attualmente).`)
	return /** @type {LocalizedString} */ (`Need at least 4 checked-in players (${i?.count} currently).`)
});